import {AUTH_KEYS} from '@/constants';
import Layout from '@/layout/Layout.vue';

export default {
    path: '/invoice-management',
    name: 'InvoiceManagement',
    component: Layout,
    meta: {
        title: 'bill_management',
        root: true,
        auth: AUTH_KEYS.BILL_MANAGEMENT
    },
    children: [
        {
            path: '/invoice-management',
            meta: {
                title: 'bill_management',
                auth: AUTH_KEYS.BILL_MANAGEMENT,
                isHide: true,
                noBreadcrumb: true
            },
            component: () => import('@/views/BillManagement/BillManagement.vue')
        },
        {
            path: '/invoice-management/register',
            meta: {title: 'invoice_registration', auth: AUTH_KEYS.BILL_REGISTRATION, isHide: true},
            component: () => import('@/views/BillManagement/BillRegistration.vue')
        },
        {
            path: '/invoice-management/detail/:id',
            meta: {
                title: 'bill_details',
                auth: AUTH_KEYS.BILL_DETAILS,
                isHide: true,
                notClickable : true
            },
            component: () => import('@/views/BillManagement/BillDetail.vue')
        }
    ]
};
